
export enum SortingHintType {
	ASC = "ASC",
	DESC = "DESC"
};
